import { makeStyles } from '@material-ui/core/styles';
import { SecondaryColors, TextColors } from '@/utils/constants';

const lightTheme = {
  root: {
    '& $metric': {
      color: SecondaryColors.dark,
    },
    '& $description': {
      color: TextColors.dark,
    },
  },
};
const darkTheme = {
  root: {
    '& $metric': {
      color: SecondaryColors.main,
    },
    '& $description': {
      color: TextColors.light,
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '&.light-theme': lightTheme.root,
      '&.dark-theme': darkTheme.root,
      width: '100%',
    },
    metric: {
      '&.Muitypography-root': {
        '&:not(:last-child)': {
          [muiTheme.breakpoints.up('md')]: {
            marginBottom: muiTheme.spacing(2),
          },
        },
      },
    },
    description: {
      wordWrap: 'normal',
    },
  }),
  { name: 'GenDynamicStatsStat' },
);

export default useStyles;
